import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
// var db = new PouchDB("admindb");

const state = {
country : undefined,
 search : "",
 isActive: undefined,
};

const mutations = {
  // setuser(state, user) {
    SET_SEARCH: (state, search) => {
    console.log(search.country, "HHHHHHHHHHHHHDFDSIFDIFDFHODFDOSFDSOFDSOF")
    state.country =  search.country ;
    state.search = search.search ;
    state.isActive = search.isActive;
  },
 
};

const actions = {
    onSearchClick: async ({commit}, payload) => {
    console.log('hdhdhddh',payload)
    commit("SET_SEARCH", payload);
  }
};
const getters = {
  getCountry: state => state.country,
  getsearch: state => state.search,
  getIsActive: state => state.isActive,
  
};



export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
